import { Component, NgZone, OnInit , EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import * as $ from 'jquery';
import { PlanNotificationService } from './PlanNotification.service';
import { environment  } from 'src/environments/environment';
import { NavigationService } from '../../../Shared/Service/Navigation.service';
import { Common } from '../../../Shared/Utility/Common'
import { CommonapiService } from '../../Service/Commonapi.service';
import * as moment from 'moment';

@Component({

  selector: 'app-PlanNotification',
  templateUrl: './PlanNotification.component.html' ,
  styleUrls: ['./PlanNotification.component.scss'],
})

export class PlanNotificationComponent implements OnInit {


  @Input() parentState: any = "";

  @Output() Submit_Event: EventEmitter<string> = new EventEmitter<string>();


  notificationList :any= [];
  constructor(private route: ActivatedRoute,private router: Router,private planNotificationServiceapi: PlanNotificationService,public api: CommonapiService){}

  state: any = {

            // contactName: { value: "", iserr: false, err_txt: "" },


            // notificationList:[],

  }

  ngOnInit()
  {
    //console.log('ngonit');
    $('#planNotificationPopup').addClass('pop_active_card');
    this.GetPlanNotificationList();

  }

  async GetPlanNotificationList(){
   // console.log('GetPlanNotificationList');
    notificationList : [];
    var postdata = { "userId": ""  };

      //this.Winfoapi.loader.startLoading();

        this.planNotificationServiceapi.GetPlanNotificationList(postdata, false).then(data => {
        //console.log("GetNotificationCount data",data)
        //undefined - bad request
        //[] - no records
        if (data && data!= undefined && data != '[]') {
          this.notificationList = data;

        // console.log(this.notificationList);
        }
       // this.Winfoapi.loader.stopLoading();

    });

  }

  DisplayReadMessageClass(obj)
  {
    //console.log('obj', obj)
    if(obj.unread == "1") //read
    {
      return false;
    }
    else
    {
      return true;
    }

  }

  ClosePlanNotificationList()
  {
    $('#planNotificationPopup').removeClass('pop_active_card');
  }

  redirectToCalendarPage(obj)
  {
    console.log("redirectToCalendarPage",obj);

    
    if(obj != null && obj.title != null && obj.title != '' && obj.title != undefined &&
       (obj.title.includes("trip has been approved") || obj.title.includes("trip has been rejected")  || obj.title.includes("trip has been unapproved")))
    {
      $('#planNotificationPopup').removeClass('pop_active_card');
      this.router.navigate(['/user/tripplancalendar']);
    }
    else if(obj.calendar_date != '' && obj.calendar_date != undefined)
    {
      const format1 = "YYYY-MM-DD";
      let formattedcurrentDate = moment(obj.calendar_date).format(format1);
      $('#planNotificationPopup').removeClass('pop_active_card');
      //this.router.navigate(['/user/plancalendar'], { queryParams: { calenderDate: formattedcurrentDate} });
       this.router.navigate(['/user/plancalendar'], { queryParams: { calenderDate: formattedcurrentDate,  customerid: obj.customer_id} });
    }

  }

  showTitle(obj)
  {
    //console.log(obj.created_date);

    if(obj.calendar_date != '' && obj.calendar_date != undefined)
    {

      let format1 = "DD MMMM YYYY";
      let formattedcurrentDate = moment(obj.calendar_date).format(format1);

      return obj.title + " on " + formattedcurrentDate;

    }
    else{
      return obj.title;
    }



  }

}
